import type { PropulsionType, VehicleData } from '@fleet/shared';
import { apiFetch } from './client';

/** Listensicht — `colorHex` ist hier die *effektive* Farbe. */
export interface VehicleListItem {
  id: string;
  licensePlate: string;
  displayName: string;
  make?: string;
  model?: string;
  seats?: number;
  colorHex: string;
  privateUseAllowed: boolean;
  isActive: boolean;
  vehicleGroup: { id: string; name: string; colorHex: string };
  canBook: boolean;
  /**
   * Darf der Aufrufer Buchungen dieser Fahrzeuggruppe freigeben?
   *
   * Gruppenbezogen und deshalb nicht durch `me.canApproveBookings` ersetzbar:
   * Wer die Poolfahrzeuge freigibt, ist bei den Wagen der Geschäftsführung ein
   * gewöhnlicher Nutzer.
   */
  canApprove: boolean;
  hasDevice: boolean;
}

/**
 * Detailsicht mit den Rohwerten — die Grundlage des Bearbeitungsformulars.
 *
 * `colorHex` ist hier bewusst optional: nicht gesetzt heißt, dass die
 * Gruppenfarbe gilt. Würde man stattdessen die effektive Farbe laden und
 * zurückschreiben, wäre die Vererbung nach dem ersten Speichern still weg.
 */
export interface VehicleDetail {
  id: string;
  licensePlate: string;
  displayName: string;
  vehicleGroupId: string;
  vehicleGroup: { id: string; name: string; colorHex: string };
  make?: string;
  model?: string;
  vin?: string;
  seats?: number;
  notes?: string;
  colorHex?: string;
  effectiveColorHex: string;
  grossListPriceCent?: number;
  firstRegistrationDate?: string;
  propulsionType: PropulsionType;
  co2GramsPerKm?: number;
  electricRangeKm?: number;
  privateUseAllowed: boolean;
  inServiceFrom: string;
  inServiceTo?: string;
  isActive: boolean;
  canBook: boolean;
  hasDevice: boolean;
}

export const vehiclesApi = {
  list: (includeInactive = false) =>
    apiFetch<VehicleListItem[]>(`/api/v1/vehicles?includeInactive=${includeInactive}`),

  detail: (id: string) => apiFetch<VehicleDetail>(`/api/v1/vehicles/${id}`),

  create: (body: VehicleData) =>
    apiFetch<{ id: string }>('/api/v1/vehicles', { method: 'POST', body: JSON.stringify(body) }),

  /** Vollständiges Ersetzen — siehe Anmerkung bei den Fahrzeuggruppen. */
  update: (id: string, body: VehicleData) =>
    apiFetch<void>(`/api/v1/vehicles/${id}`, { method: 'PUT', body: JSON.stringify(body) }),

  /** Außer Dienst stellen. Setzt zugleich das Ende der Nutzungsdauer. */
  retire: (id: string) => apiFetch<void>(`/api/v1/vehicles/${id}`, { method: 'DELETE' }),
};
